import { useState } from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import accessGroupMemberships from 'modules/dashboard/store/collections/AccessGroupMemberships'
import groups from 'modules/dashboard/store/collections/communities/Groups'

import GroupSelector from './GroupSelector'

interface Props {
  onClose: () => void
}

function JoinGroup({ onClose }: Props) {
  const [groupId, setGroupId] = useState<number | null>(null)

  const { running, performAction: submit } = useAsyncAction(async (closePortal: ClosePortalFn) => {
    if (!groupId) return

    const group = groups.find({
      id: groupId,
    })

    if (!group) {
      return
    }

    const membership = await group.rpc('join')

    accessGroupMemberships.add(membership)
    closePortal()
  })

  return (
    <Modal
      title={i18n.t('dashboard.groups.join.title')}
      description={i18n.t('dashboard.groups.join.description')}
      illustration="group"
      onClose={onClose}
      onSubmit={submit}
      footer={
        <Button disabled={!groupId || running} submit>
          {i18n.t('dashboard.groups.join.submit')}
        </Button>
      }
    >
      <GroupSelector selectedGroupId={groupId} onSelect={(number) => setGroupId(number)} />
    </Modal>
  )
}

export default observer(JoinGroup)
